<div class="bg-shui-base-2 p-4 rounded-md border border-shui-base-1 relative">
    <div
        class="flex justify-end items-center rounded-full z-20 cursor-pointer bg-shui-base-1 absolute -top-2 -right-2"
        (click)="onCancel()"
    >
        <sh-icon icon="cancel" button class="scale-[0.4]"></sh-icon>
    </div>
    <div class="flex flex-col gap-3 pt-4" [formGroup]="form">
        <sh-datepicker-accessor
            [label]="
                ('common.out-of-office.manager.start-date' | translate) +
                ' - ' +
                ('common.out-of-office.manager.end-date' | translate)
            "
            formControlName="dateRange"
            [pastDateDisable]="true"
            [range]="true"
        ></sh-datepicker-accessor>
        <sh-user-picker
            [label]="'common.out-of-office.manager.coverage' | translate"
            formControlName="user"
        ></sh-user-picker>
        <div class="flex items-center justify-end gap-2 pt-1">
            @if (mode() === 'edit') {
                <sh-button
                    [label]="'common.general.delete' | translate"
                    color="tertiary"
                    size="max-content"
                    [disabled]="isSaving()"
                    (click)="onDelete()"
                ></sh-button>
            }
            <sh-button
                [label]="
                    mode() === 'create' ? ('common.general.create' | translate) : ('common.general.update' | translate)
                "
                size="max-content"
                [disabled]="isSaving()"
                [icon]="isSaving() ? 'loading' : null"
                icon-position="end"
                (click)="onUpdate()"
            ></sh-button>
        </div>
    </div>
</div>
